'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLayersClear = function MdLayersClear(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.5 1.6l31.1 31.3-2.1 2.1-6.2-6.3-8.3 6.4-15-11.7 2.7-2.1 12.3 9.6 5.9-4.6-2.4-2.3-3.5 2.6c-5-3.8-10-7.7-15-11.6l5.4-4.2-7-7z m29.5 13.4c-2.3 1.7-4.5 3.5-6.7 5.2l-13.1-13.1 4.8-3.7z m-2 10l-2.4-2.4 2-1.5 2.4 2.3z' })
        )
    );
};

exports.default = MdLayersClear;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/layers-clear.js
// module id = 3023
// module chunks = 0